import get from 'lodash/get';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useFieldValidation } from '../../Form';
import { FormLabel } from '../FormCommons';
import { Box, Checkbox, CheckInput } from './CheckboxCommons';

interface FormCheckboxProps {
    name: string;
    label: string;
    disabled?: boolean;
}

export const FormCheckbox = ({ label, name, disabled = false }: FormCheckboxProps) => {
    const {
        register,
        watch,
        formState: { errors },
    } = useFormContext();

    const checked = watch(name);
    const error = get(errors, name);
    const { isRequired } = useFieldValidation(name);

    return (
        <Checkbox>
            <CheckInput id={name} type="checkbox" {...register(name)} disabled={disabled} />
            <Box $error={error !== undefined && error.message !== undefined} $checked={checked}>
                {checked && '✔'}
            </Box>
            <FormLabel as="span">
                {label}
                {isRequired && '*'}
            </FormLabel>
        </Checkbox>
    );
};
